import { BotService } from '../../services/bot';

const state = {
  channels: [],
};

const getters = {
  channels: (state) => state.channels,
};

const actions = {
  loadChannels({ rootGetters, commit }) {
    // check if channels are already loaded
    const channels = rootGetters['bots/currentBot'].channels;
    commit('setValue', { key: 'channels', value: channels });
  },
  addSnackbarMessage({ commit }, { message }) {
    const alert = {
      message,
      type: 'error',
      scopes: ['channels'],
    };

    commit('hubUi/addAlert', alert, { root: true });
  },
  async updateChannel({ commit, dispatch }, { botId, channel }) {
    const { success, data: updatedBot, error } = await BotService.updateChannel({ botId, channel });

    if (!success || !updatedBot) {
      const details = error ? ` Error: ${error}` : '';
      const message = `Failed to update channel '${channel.channelId}'.${details}`;
      dispatch('addSnackbarMessage', { message });
      return { success: false, error: message };
    }

    if (!updatedBot.channels) {
      dispatch('addSnackbarMessage', { message: `Updated bot does not have channels` });
      return { success: false, error: 'Updated bot does not have channels' };
    }

    commit('setValue', { key: 'channels', value: updatedBot.channels });
    return { success: true, data: updatedBot.channels };
  },
};

const mutations = {
  setValue(state, { key, value }) {
    state[key] = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
